export default {"src":"/_next/static/media/sogi.ba2156e4.svg","height":133,"width":182,"blurWidth":0,"blurHeight":0};